import { InjectionToken } from '@angular/core';

export type GraphqlApis = {
  [x: string]: string;
  productsApi: string;
  baskets: string;
  accounts: string;
};

export const defaultOptions: {
  [key: string]: {};
} = {
  productsApi: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
  baskets: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
  accounts: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
};

/**
 * Injection token for the graphql API
 */
export const GRAPHQL_API = new InjectionToken<GraphqlApis>('GraphQL API url');
